import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12d630cc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/favourite/_favourite.scss?vue&type=style&index=0&id=12d630cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d630cc",
  null
  
)

export default component.exports